export default __webpack_public_path__ + "static/media/103cdec035170111b4e007fc57992fac1581611611964.3c8ff8fd.webp";